import CollapseCaret from 'components/ContentSection/CollapseCaret.vue';

export default {
  components: {
    CollapseCaret,
  },

  props: {
    columns: {
      type: Array,
      default() { return []; },
      // TODO: Add custom validator to verify the _format_ of the columns prop when not empty!
    },
    inContainer: {
      type: Boolean,
      default: true,
    },
    renderActionColumn: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
};
